import * as React from "react";
export const useLatest = (value) => {
    const ref = React.useRef(value);
    ref.current = value;
    return ref;
};
